export default "__VITE_ASSET__BniR7BzZ__"